import { defineStore } from 'pinia';
import api from '@/api';

export const useStationStore = defineStore('station', {
  state: () => ({
    stations: [],
    station: null,
    lookups: [],
    userLookups: [],
    users: [],
    total: 0,
    loading: false,
    usersLoading: false,
    error: null
  }),

  getters: {
    getStations: (state) => state.stations,
    getStation: (state) => state.station,
    getLookups: (state) => state.lookups,
    getUserLookups: (state) => state.userLookups,
    getUsers: (state) => state.users,
    getTotal: (state) => state.total,
    isLoading: (state) => state.loading,
    isUsersLoading: (state) => state.usersLoading
  },

  actions: {
    async fetchStations(params = {}) {
      this.loading = true;
      this.error = null;
      try {
        const response = await api.station.getStations(params);
        this.stations = response.data.items || [];
        this.total = response.data.total || 0;
      } catch (error) {
        this.error = error;
        throw error;
      } finally {
        this.loading = false;
      }
    },

    async fetchStation(id) {
      this.loading = true;
      this.error = null;
      try {
        const response = await api.station.getStation(id);
        this.station = response.data;
      } catch (error) {
        this.error = error;
        throw error;
      } finally {
        this.loading = false;
      }
    },

    async fetchLookups() {
      try {
        const response = await api.station.getLookups();
        this.lookups = response.data || [];
      } catch (error) {
        this.error = error;
        throw error;
      }
    },

    async fetchUserLookups() {
      try {
        const response = await api.station.getUserLookups();
        this.userLookups = response.data || [];
      } catch (error) {
        this.error = error;
        throw error;
      }
    },

    async createStation(data) {
      this.loading = true;
      this.error = null;
      try {
        const response = await api.station.createStation(data);
        return response.data;
      } catch (error) {
        this.error = error;
        throw error;
      } finally {
        this.loading = false;
      }
    },

    async updateStation(id, data) {
      this.loading = true;
      this.error = null;
      try {
        const response = await api.station.updateStation(id, data);
        return response.data;
      } catch (error) {
        this.error = error;
        throw error;
      } finally {
        this.loading = false;
      }
    },

    async deleteStation(id) {
      this.loading = true;
      this.error = null;
      try {
        await api.station.deleteStation(id);
      } catch (error) {
        this.error = error;
        throw error;
      } finally {
        this.loading = false;
      }
    },

    // User-Station assignments
    async fetchStationUsers(stationId, params = {}) {
      this.usersLoading = true;
      this.error = null;
      try {
        const response = await api.station.getStationUsers(stationId, params);
        this.users = response.data || [];
      } catch (error) {
        this.error = error;
        throw error;
      } finally {
        this.usersLoading = false;
      }
    },

    async assignUser(stationId, data) {
      this.usersLoading = true;
      this.error = null;
      try {
        const response = await api.station.assignUser(stationId, data);
        return response.data;
      } catch (error) {
        this.error = error;
        throw error;
      } finally {
        this.usersLoading = false;
      }
    },

    async updateUserAssignment(stationId, userStationId, data) {
      this.usersLoading = true;
      this.error = null;
      try {
        const response = await api.station.updateUserAssignment(stationId, userStationId, data);
        return response.data;
      } catch (error) {
        this.error = error;
        throw error;
      } finally {
        this.usersLoading = false;
      }
    },

    async removeUser(stationId, userStationId) {
      this.usersLoading = true;
      this.error = null;
      try {
        await api.station.removeUser(stationId, userStationId);
      } catch (error) {
        this.error = error;
        throw error;
      } finally {
        this.usersLoading = false;
      }
    },

    clearStation() {
      this.station = null;
      this.users = [];
    },

    clearStations() {
      this.stations = [];
      this.total = 0;
    }
  }
});
